import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=7824d7f4&scoped=true&"
import script from "./Tiles.vue?vue&type=script&lang=js&"
export * from "./Tiles.vue?vue&type=script&lang=js&"
import style0 from "./Tiles.vue?vue&type=style&index=0&id=7824d7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824d7f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLinkApp: require('/app/components/storyblok/ui/LinkApp.vue').default})
